function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m677.17 335.33c-85.488-124.19-215.29-196.73-327.17-196.73-111.89 0-241.69 72.543-327.19 196.73-2.7578 4.0039-5.3125 9.3359-5.3125 14.672 0 5.3398 2.5547 10.664 5.3125 14.672 85.5 124.19 215.3 196.73 327.18 196.73 111.89 0 241.68-72.543 327.17-196.73 2.7773-4.0078 5.332-9.332 5.332-14.672 0-5.3359-2.5547-10.668-5.3281-14.672zm-327.17 167.36c-84.32 0-152.69-68.363-152.69-152.69s68.363-152.69 152.69-152.69 152.69 68.363 152.69 152.69-68.363 152.69-152.69 152.69z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.99 333.7c-23.02 0-41.699-18.672-41.699-41.699 0-16.168 9.2148-30.156 22.652-37.078-12.02-4.9375-25.156-7.6992-38.953-7.6992-56.754 0-102.77 46.016-102.77 102.77 0 56.746 46.016 102.77 102.77 102.77 56.762 0 102.77-46.012 102.77-102.77 0-13.805-2.7617-26.941-7.6992-38.961-6.9102 13.445-20.898 22.668-37.074 22.668z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.4c32939234cb3efc8ce79ff4d4e4d0eb.svg";
export { ForwardRef as ReactComponent };